<template src="./index.html"></template>
<style src="./index.scss?20221005" lang="scss" scoped></style>
<script>
import { Tabbar, TabbarItem } from 'vant';
import { mapState } from 'vuex';
export default {
  name:'SelfTabbar',
  components:{ Tabbar, TabbarItem},
  computed:{
    ...mapState({
      TabbarMap: (state) => {
        return state.Public.TabbarMap;
      },
      TabbarActive: (state) => {
        return state.Public.TabbarActive;
      },
      getSappMenuInfo: (state) => {
        return state.Public.getSappMenuInfo;
      },
      UserInfo: (state) => {
          return state.Public.UserInfo;
      },
    }),
  },
  methods:{
    TabbarChange(index) {
      // tabbar切换
      window.scrollTo(0, 0);
      if(this.TabbarMap[index].path == 'YesterdayBriefing') {
        let param = {
          btn_name: '昨日简报',
          vid: this.UserInfo.briefing_visitor_id, 
          page_param: {}
        }
        this.$store.dispatch('Public/inH5Record', param).then((res)=> {
          this.$router.push({ name: this.TabbarMap[index].path });
        })
      }else {
        this.$router.push({ name: this.TabbarMap[index].path });
      }
    },
  }
}
</script>